import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import HelpText from '../../components/help/HelpText';

import { adminUser, retailUser, renderErrorWarning, renderErrors } from '../../utilities/Forms.js'
import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

class DataRetention extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    retention_period: "",

    loaded: false,
    unauthorized: "",
    error: "",
    errors: ""
  };

  handleChange(event) {
    const name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    var json = JSON.stringify({
     "organisation": {
       "retention_period": this.state.retention_period
     }
    })

    request('PUT', '/v1/a/organisations/0', json, () => { this.setState({ unauthorized: true }) })
      .then(data => {
        this.setState({ errors: "" })

        sessionStorage.setItem("updateSuccess", "Retention Period updated successfully!");
        this.props.updatePopupCallback(Math.random())
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ errors: error })
      })

    event.preventDefault();
  }

  renderSaveButton() {
    if (adminUser()) {
      return <input className="right" type="submit" value="Save" />
    }
    else {
      return <input className="right" type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderRetentionPeriod() {
    const words = {
      1: ["one year"],
      2: ["two years"],
      3: ["three years"],
      4: ["four years"],
      5: ["five years"],
      6: ["six years"],
      7: ["seven years"],
      8: ["eight years"],
      9: ["nine years"],
      10: ["ten years"]
    };

    return words[this.state.retention_period]
  }

  renderMidPeriod() {
    const words = {
      1: ["six months"],
      2: ["one year"],
      3: ["one and a half years"],
      4: ["two years"],
      5: ["two and a half years"],
      6: ["three years"],
      7: ["three and a half years"],
      8: ["four years"],
      9: ["four and a half years"],
      10: ["five years"]
    };

    return words[this.state.retention_period]
  }

  render() {
    const { retention_period, loaded, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div>
          <div>
            <p>You may want to delete Person data after a certain amount of time of inactivity. Below you can find a slider to decide how long the data should be stored before deletion.</p>
            <p>If the time period is set to {this.renderRetentionPeriod()}, and a Person has not Arrived or Left in over {this.renderRetentionPeriod()}, all their data (Person record, Events, Photos, Feedback, Actions, etc etc) will be deleted.</p>
            <p>If the time period is set to {this.renderRetentionPeriod()}, and a Person Arrives or Leaves once every {this.renderMidPeriod()}, their data will be kept indefinitely. Should they stop Arriving or Leaving for longer than {this.renderRetentionPeriod()}, all their data will be deleted.</p>
            {!retailUser() && (
              <p>Residents will not be deleted, unless they are unassigned from all Locations and have not have any activity in over {this.renderRetentionPeriod()}.</p>
            )}
          </div>

          <form className="settings big-settings top-padding" onSubmit={this.handleSubmit}>
            <HelpText page={'organisation'} section={'retention_period'} />
            
            <div className="left">One year</div>
            <div className="right">Ten years</div>

            { renderErrors(errors, 'retention_period') }
            <input type="range" min="1" max="10" name="retention_period" value={retention_period} onChange={this.handleChange} />
            
            <div className="row bottom-margin center">
              Person data will be deleted after <strong>{this.renderRetentionPeriod()}</strong> of inactivity.
            </div>

            <div className="row padding-bottom-30">
              { this.renderSaveButton() }
              { renderErrorWarning(errors) }
            </div>
          </form>
        </div>
      );
    }
  }

  componentDidMount() {
    request('GET', '/v1/a/organisations/0', null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          retention_period: data.retention_period,
          loaded: true
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, loaded: true })
      })
  }
}


export default DataRetention;
